'use strict';

const formValidation = require('base/components/formValidation');
const createErrorNotification = require('base/components/errorNotification');
const baseLogin = require('base/login/login');

const { queryFirst, addClass, removeClass, loadInput } = require('../domUtil');
const { formatPhoneNumber, getItemFromLocalStorage } = require('../util');
const registrationFormPhone = queryFirst('.registration-form-phone');
const loyaltyGuestReferralModal = queryFirst('#guest-friend-referral-popup');
const $body = $('body');
const REDIRECT_TIMEOUT = 2000;
let redirectProcess;
let isRedirected = false;

window.addEventListener('load', (event) => {
    const formElement = queryFirst('.change-password-form');
    const referrerID = getItemFromLocalStorage('REFERRED_ID');
    if (referrerID && formElement) {
        loadInput(referrerID, formElement);
    }
    if (loyaltyGuestReferralModal) {
        $(loyaltyGuestReferralModal).modal('show');
    }
    // only when page loaded, enable the submit buttons
    $('.submit-signin, .create-account-btn, .submit-status')
        .attr('disabled', false)
        .attr('type', 'submit')
        .removeAttr('title');
});

module.exports = {
    ...baseLogin,

    login: function () {
        /*
        This event finishes the form.login submission response processing with redirect
        */
        $(document).one('login:success:gtm', function(event, data) {
            if (data?.redirectUrl && !isRedirected) {
                clearTimeout(redirectProcess);
                isRedirected = true;
                window.location.href = data.redirectUrl;
            }
        });
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        form.spinner().stop();
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        // redirect moved to event "login:success" processor
                        redirectProcess = setTimeout(() => {
                            if (!isRedirected) {
                                isRedirected = true;
                                window.location.href = data.redirectUrl;
                            }
                        }, REDIRECT_TIMEOUT);
                    }
                },
                error: function (data) {
                    if (data.responseJSON && data.responseJSON.csrfError) {
                        form.spinner().stop();
                        data.csrfModalHandled = true;
                        $body.trigger('csrf:error', { useLegacyCopy: true });
                        $('form.login').trigger('login:error', data);
                    } else if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        form.spinner().stop();
                        $('form.login').trigger('login:error', data);
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        /*
        This event finishes the form.registration submission response processing with redirect
        */
        $(document).one('register:success:gtm', function(event, data) {
            if (data?.redirectUrl && !isRedirected) {
                clearTimeout(redirectProcess);
                isRedirected = true;
                window.location.href = data.redirectUrl;
            }
        });
        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $body.spinner().start();
            form.trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        form.trigger('register:success');
                        // redirect moved to event "register:success" processor
                        redirectProcess = setTimeout(() => {
                            if (!isRedirected) {
                                isRedirected = true;
                                console.debug('TIMEOUT on GTM confirmation, redirecting to:', data.redirectUrl);
                                window.location.href = data.redirectUrl;
                            }
                        }, REDIRECT_TIMEOUT);
                    } else {
                        $body.spinner().stop();
                        formValidation(form, data);
                        form.trigger('register:error');
                    }
                },
                error: function (err) {
                    if (err.responseJSON && err.responseJSON.csrfError) {
                        $body.spinner().stop();
                        err.csrfModalHandled = true;
                        $body.trigger('csrf:error', { useLegacyCopy: true });
                        form.trigger('register:error');
                    } else if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        $body.spinner().stop();
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        const resetPasswordDialog = $('#requestPasswordResetModal');

        resetPasswordDialog.on('hidden.bs.modal', function () {
            removeClass(queryFirst('.password-reset-section', this), 'request-success');
            const emailEl = document.getElementById('reset-password-email');
            emailEl.value = '';
            removeClass(emailEl, 'is-invalid');
        });

        $('.reset-password-form').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        // LP Customization start
                        addClass(queryFirst('.reset-password-request-modal .password-reset-section'), 'request-success');
                        // LP Customization end
                    }
                },
                error: function (err) {
                    form.spinner().stop();
                    if (err) {
                        err.csrfModalHandled = true;
                    }
                    resetPasswordDialog.modal('hide').one('hidden.bs.modal', () => {
                        $body.trigger('csrf:error', { useLegacyCopy: true });
                    });
                }
            });

            return false;
        });
    },
    handleLogin: function () {
        const loginBtnEl = queryFirst('.account-login-btn');
        const $loginFormEl = $('form.login');
        $loginFormEl.on('login:submit', function () {
            loginBtnEl.disabled = true;
        });

        $loginFormEl.on('login:error', function () {
            loginBtnEl.disabled = false;
        });
    }
};

formatPhoneNumber(registrationFormPhone);
